var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 175.34 240.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9ca6d4;\n      }\n\n      .cls-2 {\n        fill: #48509f;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #151922;\n      }\n\n      .cls-5 {\n        fill: #020609;\n      }\n\n      .cls-6 {\n        fill: #9ea8d5;\n      }\n\n      .cls-7 {\n        fill: #eeeef7;\n      }\n\n      .cls-8 {\n        fill: #dcdfec;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.67,97.53s-34.59-17.95-66.11-46.36c-9.4,17.39-15.95,36.91-15.95,57.53,0,72.98,82.06,132.14,82.06,132.14,0,0,82.06-59.16,82.06-132.14,0-20.62-6.55-40.14-15.95-57.53-31.52,28.41-66.11,46.36-66.11,46.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.67,95.66s-33.49-9.72-64-37.22c-9.1,16.83-13.45,35.72-13.45,55.67,0,70.62,77.45,113.38,77.45,113.38,0,0,77.45-42.76,77.45-113.38,0-19.95-4.34-38.84-13.45-55.67-30.51,27.49-64,37.22-64,37.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.49,131.91s-15.93-32.84-25.15-27.16l-7.03-17.05,2.44-8.12-17.68-9.93s-13.26,42.26,10.11,63.95c0,0-11.37-5.89-15.58-11.58,0,0,3.58,39.37,31.79,51.16,0,0-10.95-.63-14.95-4l26.95,31.79,9.11-69.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.75,131.91s15.93-32.84,25.15-27.16l7.03-17.05-2.44-8.12,17.68-9.93s13.26,42.26-10.11,63.95c0,0,11.37-5.89,15.58-11.58,0,0-3.58,39.37-31.79,51.16,0,0,10.95-.63,14.95-4l-26.95,31.79-9.11-69.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.76,70.6c2.58.07,4.6-.24,5.72-.7,0,0-17.44,1.94-22.68-11.01,29.43.82-8.87,5.13-14.91-16.23,3.67,1.63,8.38,2.7,14.42,2.7.71,0-18.52-.09-22.94-16.13,7.59,2.5,28.14,3.94,28.15,3.94C48.5,33.17-1.51,32.73.04,0c7.32,7.33,20.76,13.32,43.8,16.27,48.62,7.9,34.01,35.33,38.79,59.76-.93-.91-2.21-3.72-3.9-3.02-5.56,2.38-16.8,2.51-18.95-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.48,45.13c-3.39-29.13-31.67-25.23-64.02-35.19,7.01,3.2,16.02,5.96,27.51,8.09,45.4,10.3,32.39,32.57,36.45,53.25.53,0-.1,1.89.24,2.32l1.96,2.44-2.14-30.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M115.58,70.6c-2.58.07-4.6-.24-5.72-.7,0,0,17.44,1.94,22.68-11.01-29.43.82,8.87,5.13,14.91-16.23-3.67,1.63-8.38,2.7-14.42,2.7-.71,0,18.52-.09,22.94-16.13-7.59,2.5-28.14,3.94-28.15,3.94-.99,0,49.03-.44,47.48-33.17-7.32,7.33-20.76,13.32-43.8,16.27-48.62,7.9-34.01,35.33-38.79,59.76.93-.91,2.21-3.72,3.9-3.02,5.56,2.38,16.8,2.51,18.95-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.86,45.13c3.39-29.13,31.67-25.23,64.02-35.19-7.01,3.2-16.02,5.96-27.51,8.09-45.4,10.3-32.39,32.57-36.45,53.25-.53,0,.1,1.89-.24,2.32l-1.96,2.44,2.14-30.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.65,6.93c7.76,0,14.08,4.58,14.13,10.22,0,0-.65,66.85-14.13,65.81-14.13,0-14.13-65.81-14.13-65.81.05-5.64,6.37-10.22,14.13-10.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.71,81.44c-14.7,1.73-28.07-1.52-32.25-2.69-16.21-1.5-22.12,4.78-45.59,2.69l-3.2,7.12,10.93,10.72c3.84-2.11,58.53-2.11,62.37,0l10.93-10.72-3.2-7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.62,89.01l1.79-5.6c11.73,1.38,22.57-2.07,28.6-4.11-5.61,1.39-17.37,3.64-30.14,2.14l-3.2,7.12,10.03,9.84-7.09-9.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.96,89.01l-1.79-5.6c-11.73,1.38-22.57-2.07-28.6-4.11,5.61,1.39,17.37,3.64,30.14,2.14l3.2,7.12-10.03,9.84,7.09-9.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.64,90.11c.85-2.18-.43-5.33-2.55-5.61-.3.02-.63,0-.93,0-6.6,1.91-.05,13.21,3.48,5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.96,79.78c.2,3.02-4.3,3.77-6.77,3.43-7.32-.96-1.16-11.63,1.6-12.23,1.77.03,5.05,5.59,5.17,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.02,78.77c.13,1.89-2.68,2.35-4.23,2.14-4.57-.6-.73-7.26,1-7.64,1.11.02,3.15,3.49,3.23,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.67,126.86c27.66,0,32.46,30.15,33.29,40.69.15,1.94-1.39,3.59-3.33,3.59h-.25c-1.59,0-2.91-1.14-3.27-2.69-1.59-6.81-8.57-13.86-11.62-16.68-.55-.51-1.45-.12-1.45.63v56.14s-13.37,8.93-13.37,8.93l-13.37-8.93v-56.14c0-.75-.89-1.14-1.45-.63-3.06,2.83-10.03,9.87-11.62,16.68-.36,1.55-1.68,2.69-3.27,2.69h-.25c-1.94,0-3.48-1.65-3.33-3.59.83-10.54,5.63-40.69,33.29-40.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.47,111.64c.16,11.21-17.45,11.21-17.28,0-.16-11.21,17.45-11.21,17.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.83,105.33c2.32,0,4.44.68,6.08,1.8-2.69-4.02-9.46-4.02-12.15,0,1.64-1.12,3.76-1.8,6.08-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.94,105.53c7.58,15.74-19.8,15.73-12.22,0-5.41,5.04-1.41,15.02,6.11,14.75,7.53.26,11.52-9.71,6.11-14.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "86.48 109.32 87.83 106.85 89.18 109.32 91.65 110.67 89.18 112.02 87.83 114.49 86.48 112.02 84.01 110.67 86.48 109.32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.704e388283dbf0056b36d61670c9c834.svg";
export { ForwardRef as ReactComponent };